import { blackColors, hexToRgb, primaryColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const topUpNumbersTabStyle = () => ({
	wrapper: {
		backgroundColor: whiteColor,
		borderRadius: 4,
	},
	addNumbersWrapper: {
		textAlign: 'center',
		paddingTop: 96,
		paddingBottom: 118,
	},
	addNumbersButton: {
		marginTop: 30,
	},
	tableWrapper: {
		height: '100%',
		position: 'relative',
	},
	selectedRow: {
		background: `linear-gradient(${blackColors[6]}, ${blackColors[6]}), linear-gradient(white, white)`,
	},
	editedRow: {
		background: `linear-gradient(rgba(${hexToRgb(primaryColor[0])}, 0.06), rgba(${hexToRgb(
			primaryColor[0]
		)}, 0.06)), linear-gradient(white, white)`,
	},
	manyNumbersEdit: {
		position: 'absolute',
		top: 'calc(50% + 76px)',
		left: 'calc(50% + 100px)',
	},
	icon: {
		marginBottom: '30px',
	},
});

export default topUpNumbersTabStyle;
